import User from './user';

export default class Contact extends User {
    static exportFilters = {
        isActive: false,
        enabled: true,
        roleNames: ['contributor', 'responsible']
    }
    static moduleName = 'contacts';
}